ScoreCardUtilityService = ->
  yardToMeter: (yard) ->
    if yard then yard*0.9144

module.exports = ScoreCardUtilityService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-utility-service.coffee